import { render, staticRenderFns } from "./EmojiRise.vue?vue&type=template&id=b55c6f42&scoped=true"
import script from "./EmojiRise.vue?vue&type=script&lang=js"
export * from "./EmojiRise.vue?vue&type=script&lang=js"
import style0 from "./EmojiRise.vue?vue&type=style&index=0&id=b55c6f42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55c6f42",
  null
  
)

export default component.exports